import { render, staticRenderFns } from "./GlobalColorsInput.vue?vue&type=template&id=7b64e62b&"
import script from "./GlobalColorsInput.vue?vue&type=script&lang=ts&"
export * from "./GlobalColorsInput.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalColorsInput.vue?vue&type=style&index=0&id=7b64e62b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports